import { render, staticRenderFns } from "./ModalPopUpPlanFree.vue?vue&type=template&id=d9dd5884&scoped=true"
import script from "./ModalPopUpPlanFree.vue?vue&type=script&lang=ts"
export * from "./ModalPopUpPlanFree.vue?vue&type=script&lang=ts"
import style0 from "./ModalPopUpPlanFree.scss?vue&type=style&index=0&id=d9dd5884&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dd5884",
  null
  
)

export default component.exports